import React, { Dispatch, SetStateAction } from "react"
import {
  Order,
  OrderModificationShippingFees,
  OrderModificationType
} from "lib/types/generated/graphql-types"

import { ButtonWrapper, CartContainer, CartItems, EmptyContainer } from "./Cart.styled"

import CartItem from "./CartItem"
import PrimaryButton from "../../../../../Ui/Buttons/PrimaryButton"
import SecondaryButton from "../../../../../Ui/Buttons/SecondaryButton"
import { useMutation } from "@apollo/client"
import { handleErrorMessages } from "helpers/errors"
import ModificationReason from "../../ModifyShippingFees/Cart/ModificationReason"
import Totals from "./Totals"
import DELETE_SHIPPING_FEE_MODIFICATION from "../../../../../../graphql/mutations/order/modification/shippingFees/DeleteModification"

type Props = {
  order: Order
  refetch: () => void
  setShowConfirmation: Dispatch<SetStateAction<boolean>>
  summaryMode?: boolean
  orderLoading: boolean
}

export const Cart = ({
  order,
  refetch,
  setShowConfirmation,
  summaryMode = false,
  orderLoading
}: Props) => {
  const filteredModifications = order?.Modifications?.filter(
    (modification) =>
      !modification.completed &&
      !modification.started &&
      modification.type === OrderModificationType.ShippingFees
  )

  const [deleteModification, { loading: deleteLoading }] = useMutation(
    DELETE_SHIPPING_FEE_MODIFICATION,
    {
      onCompleted: () => {
        refetch()
      },
      onError: (error) => {
        handleErrorMessages(error)
      }
    }
  )

  if (!order) return null
  return (
    <>
      {filteredModifications?.length > 0 ? (
        <>
          <h2>New shipping draft</h2>
          {filteredModifications?.map((modification) => (
            <CartContainer key={modification.id}>
              <CartItems>
                {order?.shippingFees?.map((shippingFee) => (
                  <CartItem
                    currencyCode={order.currencyCode}
                    key={shippingFee.id}
                    shippingFee={shippingFee}
                    refetch={refetch}
                  />
                ))}
              </CartItems>
              <ModificationReason
                modification={modification as OrderModificationShippingFees}
                refetch={refetch}
                order={order}
                orderLoading={orderLoading}
              />
              <Totals totals={order.totals} currencyCode={order.currencyCode} />
              <ButtonWrapper>
                {!summaryMode && (
                  <SecondaryButton
                    loading={deleteLoading}
                    handleClick={() => {
                      deleteModification({ variables: { modificationId: modification.id } })
                    }}
                  >
                    Cancel modification draft
                  </SecondaryButton>
                )}
                {!summaryMode && (
                  <PrimaryButton handleClick={() => setShowConfirmation(true)}>Next</PrimaryButton>
                )}
              </ButtonWrapper>
            </CartContainer>
          ))}
        </>
      ) : (
        <>
          <h2>New order draft</h2>
          <EmptyContainer>
            <h2>Create modification to finalize.</h2>
          </EmptyContainer>
        </>
      )}
    </>
  )
}
